module.exports = __webpack_public_path__ + "Orbitz_ico.png?fb18ec7119a521bd4b7d977870a62823";